import { render, staticRenderFns } from "./RingCentralEmbeddable.vue?vue&type=template&id=442e0b63&"
import script from "./RingCentralEmbeddable.vue?vue&type=script&lang=js&"
export * from "./RingCentralEmbeddable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports